<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <div>
            <AmountSelectorYachadNjPurim/>
          </div>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.yachad.org/privacy-policy/"/>
                  </FormRow> 
          </FormSection>
          <FormSection title="">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>

          <PaymentButton showAmount btnText="Pay now" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, onMounted } from "vue";
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
    campaign: String,
  },
  setup(props) {
    const { getValue, setValue, form, submit } = usePaymentForm();

    if (props.subCampaign) {
      setValue("applications.0.subCampaign", props.subCampaign);
    }

    if (props.campaign) {
      setValue("applications.0.campaign", props.campaign);
    }

    onMounted(() => {
      const params = queryParams();

      if (params.utm_content) {
        if (
          !["Direct Mail", "Telemarketing", "Text SMS Message"].includes(
            params.utm_content
          )
        ) {
          throw new Error("Invalid subcampaign");
        }

        setValue("applications.0.subCampaign", params.utm_content);
      }
    });

    return {
      form,
      getValue,
      setValue,
      submit,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep hr {
  display: block !important;
  border-color: #efefef !important;
  margin-top: 0 !important;
  margin-bottom: 30px !important;
}
.paytext {
  font-size: 14px;
  color: #222;
  padding-top: 0px;
  line-height: normal;
  padding-bottom: 10px;
  display: block;
}
#isGapStudent {
  margin-right: 5px;
}
</style>
